var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { query, state } from 'lit/decorators.js';
import { sdsCustomElement } from '../utilities/custom-components';
import { isThisTarget } from '../utilities/picker.tools';
import { SdsActionListItem } from './sds-action-list-item.lit';
import styles from './sds-action-list.lit.scss';
import { render } from 'lit/html.js';
/**
 * A control that represents a list of actions.
 * Main purpose is to display a list of actions in sds-table and sds-tree components.
 *
 * @tag sds-action-list
 */
let SdsActionList = (() => {
    var _SdsActionList_buttonsContainer_accessor_storage, _SdsActionList_contextButtons_accessor_storage, _SdsActionList_contextMenu_accessor_storage, _SdsActionList_moreButton_accessor_storage, _SdsActionList_isThreeDotButtonVisible_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-action-list')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _buttonsContainer_decorators;
    let _buttonsContainer_initializers = [];
    let _buttonsContainer_extraInitializers = [];
    let _contextButtons_decorators;
    let _contextButtons_initializers = [];
    let _contextButtons_extraInitializers = [];
    let _contextMenu_decorators;
    let _contextMenu_initializers = [];
    let _contextMenu_extraInitializers = [];
    let _moreButton_decorators;
    let _moreButton_initializers = [];
    let _moreButton_extraInitializers = [];
    let _isThreeDotButtonVisible_decorators;
    let _isThreeDotButtonVisible_initializers = [];
    let _isThreeDotButtonVisible_extraInitializers = [];
    var SdsActionList = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsActionList_buttonsContainer_accessor_storage.set(this, __runInitializers(this, _buttonsContainer_initializers, void 0));
            _SdsActionList_contextButtons_accessor_storage.set(this, (__runInitializers(this, _buttonsContainer_extraInitializers), __runInitializers(this, _contextButtons_initializers, void 0)));
            _SdsActionList_contextMenu_accessor_storage.set(this, (__runInitializers(this, _contextButtons_extraInitializers), __runInitializers(this, _contextMenu_initializers, void 0)));
            _SdsActionList_moreButton_accessor_storage.set(this, (__runInitializers(this, _contextMenu_extraInitializers), __runInitializers(this, _moreButton_initializers, void 0)));
            _SdsActionList_isThreeDotButtonVisible_accessor_storage.set(this, (__runInitializers(this, _moreButton_extraInitializers), __runInitializers(this, _isThreeDotButtonVisible_initializers, false)));
            this.hideMenu = (__runInitializers(this, _isThreeDotButtonVisible_extraInitializers), (event) => {
                if (event && !isThisTarget(event, this, this.contextMenu)) {
                    this.hideContextMenu();
                }
            });
            this.clickHandler = (id) => {
                this.dispatchEvent(new CustomEvent(SdsActionList.ACTION, {
                    detail: {
                        id,
                    },
                }));
                this.hideContextMenu();
            };
            this.toggleContextMenu = () => {
                if (this.contextMenu && this.moreButton) {
                    if (this.contextMenu.opened) {
                        document.removeEventListener('mouseup', this.hideMenu);
                        this.hideContextMenu();
                    }
                    else {
                        document.addEventListener('mouseup', this.hideMenu);
                        this.contextMenu.show(this.moreButton);
                        this.moreButton.setAttribute('selected', 'true');
                        this.setParentTableRowClass();
                        this.publishActionMenuState();
                    }
                }
            };
            this.publishActionMenuState = () => {
                var _a;
                this.dispatchEvent(new CustomEvent(SdsActionList.ACTION_MENU_STATE, {
                    detail: {
                        opened: (_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.opened,
                    },
                }));
            };
            this.handleSlotChange = () => {
                var _a, _b;
                const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot');
                const assigned = (_b = slot === null || slot === void 0 ? void 0 : slot.assignedElements({ flatten: true })) !== null && _b !== void 0 ? _b : [];
                const buttons = assigned.filter((el) => el instanceof SdsActionListItem && el.slot === 'action');
                if (!buttons || buttons.length === 0) {
                    return;
                }
                const primaryButtons = buttons.filter(button => button.isPrimary);
                const secondaryButtons = buttons.filter(button => !button.isPrimary);
                this.isThreeDotButtonVisible = buttons.length > 5 || secondaryButtons.length > 0;
                const visiblePrimary = primaryButtons.slice(0, 4 + Number(!this.isThreeDotButtonVisible));
                render(html `${visiblePrimary.map(button => button.renderButton(this.clickHandler))}`, this.buttonsContainer);
                render(html `${[...primaryButtons, ...secondaryButtons].map(button => button.renderContextMenuItem(this.clickHandler))}`, this.contextButtons);
            };
        }
        get buttonsContainer() { return __classPrivateFieldGet(this, _SdsActionList_buttonsContainer_accessor_storage, "f"); }
        set buttonsContainer(value) { __classPrivateFieldSet(this, _SdsActionList_buttonsContainer_accessor_storage, value, "f"); }
        get contextButtons() { return __classPrivateFieldGet(this, _SdsActionList_contextButtons_accessor_storage, "f"); }
        set contextButtons(value) { __classPrivateFieldSet(this, _SdsActionList_contextButtons_accessor_storage, value, "f"); }
        get contextMenu() { return __classPrivateFieldGet(this, _SdsActionList_contextMenu_accessor_storage, "f"); }
        set contextMenu(value) { __classPrivateFieldSet(this, _SdsActionList_contextMenu_accessor_storage, value, "f"); }
        get moreButton() { return __classPrivateFieldGet(this, _SdsActionList_moreButton_accessor_storage, "f"); }
        set moreButton(value) { __classPrivateFieldSet(this, _SdsActionList_moreButton_accessor_storage, value, "f"); }
        get isThreeDotButtonVisible() { return __classPrivateFieldGet(this, _SdsActionList_isThreeDotButtonVisible_accessor_storage, "f"); }
        set isThreeDotButtonVisible(value) { __classPrivateFieldSet(this, _SdsActionList_isThreeDotButtonVisible_accessor_storage, value, "f"); }
        render() {
            return html ` <div class="sds-action-list">
            <slot style="display: none;" name="action" @slotchange=${this.handleSlotChange}></slot>
            <div id="buttons" style="display:flex; gap: 2px;"></div>
            ${this.isThreeDotButtonVisible ? this.renderMoreButton() : undefined}
            <sds-context-menu>
                <div id="context-buttons"></div>
            </sds-context-menu>
        </div>`;
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener(SdsActionListItem.ACTION_LIST_ITEM_CHANGE, this.handleSlotChange);
        }
        disconnectedCallback() {
            this.hideContextMenu();
            this.removeEventListener(SdsActionListItem.ACTION_LIST_ITEM_CHANGE, this.handleSlotChange);
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        renderMoreButton() {
            return html `
            <sds-tooltip position="up">
                <sds-button
                    id="more-button"
                    slot="trigger"
                    type="secondary"
                    size="md"
                    icon="more"
                    @click="${this.toggleContextMenu}"
                >
                </sds-button>
                More
            </sds-tooltip>
        `;
        }
        hideContextMenu() {
            var _a, _b;
            if ((_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this.contextMenu.hide();
                (_b = this.moreButton) === null || _b === void 0 ? void 0 : _b.removeAttribute('selected');
                this.removeParentTableRowClass();
                this.publishActionMenuState();
            }
        }
        setParentTableRowClass() {
            const parentTableRow = this.closest('tr');
            if (parentTableRow) {
                parentTableRow.classList.add('sds-table--action-menu-opened');
            }
            const parentTreeNode = this.closest('sds-tree-node');
            if (parentTreeNode) {
                parentTreeNode.dataset.actionListMenuOpened = 'true';
            }
            const parentListRow = this.closest('sds-list-item');
            if (parentListRow) {
                parentListRow.dataset.actionListMenuOpened = 'true';
            }
        }
        removeParentTableRowClass() {
            const parentTableRow = this.closest('tr');
            if (parentTableRow) {
                parentTableRow.classList.remove('sds-table--action-menu-opened');
            }
            const parentTreeNode = this.closest('sds-tree-node');
            if (parentTreeNode) {
                delete parentTreeNode.dataset.actionListMenuOpened;
            }
            const parentListRow = this.closest('sds-list-item');
            if (parentListRow) {
                delete parentListRow.dataset.actionListMenuOpened;
            }
        }
    };
    _SdsActionList_buttonsContainer_accessor_storage = new WeakMap();
    _SdsActionList_contextButtons_accessor_storage = new WeakMap();
    _SdsActionList_contextMenu_accessor_storage = new WeakMap();
    _SdsActionList_moreButton_accessor_storage = new WeakMap();
    _SdsActionList_isThreeDotButtonVisible_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsActionList");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _buttonsContainer_decorators = [query('#buttons')];
        _contextButtons_decorators = [query('#context-buttons')];
        _contextMenu_decorators = [query('sds-context-menu')];
        _moreButton_decorators = [query('#more-button')];
        _isThreeDotButtonVisible_decorators = [state()];
        __esDecorate(_classThis, null, _buttonsContainer_decorators, { kind: "accessor", name: "buttonsContainer", static: false, private: false, access: { has: obj => "buttonsContainer" in obj, get: obj => obj.buttonsContainer, set: (obj, value) => { obj.buttonsContainer = value; } }, metadata: _metadata }, _buttonsContainer_initializers, _buttonsContainer_extraInitializers);
        __esDecorate(_classThis, null, _contextButtons_decorators, { kind: "accessor", name: "contextButtons", static: false, private: false, access: { has: obj => "contextButtons" in obj, get: obj => obj.contextButtons, set: (obj, value) => { obj.contextButtons = value; } }, metadata: _metadata }, _contextButtons_initializers, _contextButtons_extraInitializers);
        __esDecorate(_classThis, null, _contextMenu_decorators, { kind: "accessor", name: "contextMenu", static: false, private: false, access: { has: obj => "contextMenu" in obj, get: obj => obj.contextMenu, set: (obj, value) => { obj.contextMenu = value; } }, metadata: _metadata }, _contextMenu_initializers, _contextMenu_extraInitializers);
        __esDecorate(_classThis, null, _moreButton_decorators, { kind: "accessor", name: "moreButton", static: false, private: false, access: { has: obj => "moreButton" in obj, get: obj => obj.moreButton, set: (obj, value) => { obj.moreButton = value; } }, metadata: _metadata }, _moreButton_initializers, _moreButton_extraInitializers);
        __esDecorate(_classThis, null, _isThreeDotButtonVisible_decorators, { kind: "accessor", name: "isThreeDotButtonVisible", static: false, private: false, access: { has: obj => "isThreeDotButtonVisible" in obj, get: obj => obj.isThreeDotButtonVisible, set: (obj, value) => { obj.isThreeDotButtonVisible = value; } }, metadata: _metadata }, _isThreeDotButtonVisible_initializers, _isThreeDotButtonVisible_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsActionList = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.ACTION = 'sds.action-list.action';
    _classThis.ACTION_MENU_STATE = 'sds.action-list.menu.state';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsActionList = _classThis;
})();
export { SdsActionList };
